"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenDevesting = void 0;
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
var borsh_1 = require("@solvei/borsh");
var bn_js_1 = __importDefault(require("bn.js"));
var accounts_devesting_1 = require("./accounts-devesting");
var constants_1 = require("./constants");
var query_1 = require("./query");
var schema_1 = require("./schema");
var token_vesing_1 = require("./token-vesing");
var TokenDevesting = /** @class */ (function (_super) {
    __extends(TokenDevesting, _super);
    function TokenDevesting(connection, programId, mint, sender, creator, vestingsCreator, vestingName) {
        var _this = _super.call(this, connection, programId, mint, sender, creator, vestingsCreator, vestingName) || this;
        _this.connection = connection;
        _this.programId = programId;
        _this.mint = mint;
        _this.sender = sender;
        _this.creator = creator;
        _this.vestingsCreator = vestingsCreator;
        _this.vestingName = vestingName;
        var vestingContext = _this.getContext();
        _this.multisigAccessor = new accounts_devesting_1.MultisigAccessor(vestingContext);
        _this.multisigTokenAccessor = new accounts_devesting_1.MultisigTokenAccessor(vestingContext);
        _this.devestingActionAccessor = new accounts_devesting_1.DevestingActionAccessor(vestingContext);
        _this.transferActionAccessor = new accounts_devesting_1.TransferActionAccessor(vestingContext);
        return _this;
    }
    TokenDevesting.prototype.createMultisig = function (signaturesPerOperation, signers) {
        return __awaiter(this, void 0, void 0, function () {
            var vestingType, tokenPool, config, multisig, multisigToken, instance, instructionData, createMultisigInstruction, transaction, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (signaturesPerOperation.length != constants_1.MULTISIG_OPERATIONS) {
                            throw Error("Signatures Per Operation length missmatch");
                        }
                        if (signers.length == 0 || signers.length > constants_1.MAX_SIGNERS) {
                            throw Error("Signers length missmatch");
                        }
                        while (signers.length < 11) {
                            signers.push(web3_js_1.PublicKey.default);
                        }
                        this.validateOnlyCreator();
                        return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 1:
                        vestingType = _e.sent();
                        return [4 /*yield*/, this.tokenPoolAccessor.existing()];
                    case 2:
                        tokenPool = _e.sent();
                        return [4 /*yield*/, this.configAccessor.existing()];
                    case 3:
                        config = _e.sent();
                        return [4 /*yield*/, this.multisigAccessor.nonExisting()];
                    case 4:
                        multisig = _e.sent();
                        return [4 /*yield*/, this.multisigTokenAccessor.nonExisting()];
                    case 5:
                        multisigToken = _e.sent();
                        instance = new schema_1.Instruction(new schema_1.CreateMultisigInstruction(signaturesPerOperation, signers));
                        instructionData = (0, borsh_1.serialize)(schema_1.schemas, instance);
                        createMultisigInstruction = new web3_js_1.TransactionInstruction({
                            keys: [
                                { pubkey: this.creator, isSigner: true, isWritable: false },
                                vestingType.getWritableAccountMeta(),
                                tokenPool.getAccountMeta(),
                                multisig.getWritableAccountMeta(),
                                config.getAccountMeta(),
                                multisigToken.getWritableAccountMeta(),
                                { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
                            ],
                            programId: this.programId,
                            data: Buffer.from(instructionData),
                        });
                        transaction = new web3_js_1.Transaction();
                        _b = (_a = transaction).add;
                        return [4 /*yield*/, multisigToken.getCreateInstruction()];
                    case 6:
                        _b.apply(_a, [_e.sent()]);
                        transaction.add(multisigToken.getInitInstruction());
                        _d = (_c = transaction).add;
                        return [4 /*yield*/, multisig.getCreateInstruction()];
                    case 7:
                        _d.apply(_c, [_e.sent()]);
                        transaction.add(createMultisigInstruction);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenDevesting.prototype.devestAccountAsAdministrator = function (devestingAccount) {
        return __awaiter(this, void 0, void 0, function () {
            var vestingType, config, vesting, configData, vestingTypeData, transaction, instructionData, signDevestingInstruction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 1:
                        vestingType = _a.sent();
                        return [4 /*yield*/, this.configAccessor.existing()];
                    case 2:
                        config = _a.sent();
                        return [4 /*yield*/, this.vestingAccessor.existing(devestingAccount)];
                    case 3:
                        vesting = _a.sent();
                        configData = config.data;
                        vestingTypeData = vestingType.data;
                        if (!this.sender.equals(vestingTypeData.administrator)) {
                            throw Error("Only administrator can call this method");
                        }
                        if (!configData.vesting_stop_enabled ||
                            configData.vesting_stop_multisig_enabled) {
                            throw Error("Administrator devesting isn't enabled in config!");
                        }
                        transaction = new web3_js_1.Transaction();
                        instructionData = (0, schema_1.serializeSignDevestingInstruction)();
                        signDevestingInstruction = new web3_js_1.TransactionInstruction({
                            keys: [
                                { pubkey: this.sender, isSigner: true, isWritable: false },
                                vesting.getWritableAccountMeta(),
                                vestingType.getWritableAccountMeta(),
                                config.getAccountMeta(),
                            ],
                            programId: this.programId,
                            data: Buffer.from(instructionData),
                        });
                        transaction.add(signDevestingInstruction);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenDevesting.prototype.signDevestAccount = function (devestingAccount, proposalCreator) {
        return __awaiter(this, void 0, void 0, function () {
            var vestingType, tokenPool, config, vesting, multisig, multisigToken, vestingTypeData, transaction, instructionData, devesting, devestingParams, _a, _b, devestingParams, signDevestingInstruction, _c, _d;
            var _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 1:
                        vestingType = _f.sent();
                        return [4 /*yield*/, this.tokenPoolAccessor.existing()];
                    case 2:
                        tokenPool = _f.sent();
                        return [4 /*yield*/, this.configAccessor.existing()];
                    case 3:
                        config = _f.sent();
                        return [4 /*yield*/, this.vestingAccessor.existing(devestingAccount)];
                    case 4:
                        vesting = _f.sent();
                        return [4 /*yield*/, this.multisigAccessor.existing()];
                    case 5:
                        multisig = _f.sent();
                        return [4 /*yield*/, this.multisigTokenAccessor.existing()];
                    case 6:
                        multisigToken = _f.sent();
                        vestingTypeData = vestingType.data;
                        if (!vestingTypeData.token_pool || !vestingTypeData.administrator)
                            throw Error("Vesting type does not have token pool or administrator");
                        transaction = new web3_js_1.Transaction();
                        instructionData = (0, schema_1.serializeSignDevestingInstruction)();
                        devesting = null;
                        if (!(proposalCreator === null)) return [3 /*break*/, 9];
                        devestingParams = {
                            actionCreator: this.sender,
                            vestingReceiver: devestingAccount,
                        };
                        return [4 /*yield*/, this.devestingActionAccessor.nonExisting(devestingParams)];
                    case 7:
                        devesting = _f.sent();
                        _b = (_a = transaction).add;
                        return [4 /*yield*/, devesting.getCreateInstruction()];
                    case 8:
                        _b.apply(_a, [_f.sent()]);
                        return [3 /*break*/, 11];
                    case 9:
                        devestingParams = {
                            actionCreator: proposalCreator,
                            vestingReceiver: devestingAccount,
                        };
                        return [4 /*yield*/, this.devestingActionAccessor.existing(devestingParams)];
                    case 10:
                        devesting = _f.sent();
                        _f.label = 11;
                    case 11:
                        _c = web3_js_1.TransactionInstruction.bind;
                        _e = {};
                        _d = [{ pubkey: this.sender, isSigner: true, isWritable: false },
                            vesting.getWritableAccountMeta(),
                            vestingType.getWritableAccountMeta(),
                            config.getAccountMeta(),
                            devesting.getWritableAccountMeta(),
                            multisig.getAccountMeta(),
                            tokenPool.getWritableAccountMeta(),
                            multisigToken.getWritableAccountMeta()];
                        return [4 /*yield*/, vestingType.getTokenPoolPdaAccountMeta()];
                    case 12:
                        signDevestingInstruction = new (_c.apply(web3_js_1.TransactionInstruction, [void 0, (_e.keys = _d.concat([
                                _f.sent(),
                                { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
                                {
                                    pubkey: vestingTypeData.administrator,
                                    isSigner: false,
                                    isWritable: true,
                                }
                            ]),
                                _e.programId = this.programId,
                                _e.data = Buffer.from(instructionData),
                                _e)]))();
                        transaction.add(signDevestingInstruction);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenDevesting.prototype.createAssocitedAccountsForWithdrawal = function (accounts) {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, _i, accounts_1, account, tokenAccount, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        transaction = new web3_js_1.Transaction();
                        _i = 0, accounts_1 = accounts;
                        _c.label = 1;
                    case 1:
                        if (!(_i < accounts_1.length)) return [3 /*break*/, 5];
                        account = accounts_1[_i];
                        return [4 /*yield*/, this.associatedTokenAccessor.get(account.pubkey)];
                    case 2:
                        tokenAccount = _c.sent();
                        if (!!tokenAccount.data) return [3 /*break*/, 4];
                        _b = (_a = transaction).add;
                        return [4 /*yield*/, tokenAccount.getCreateInstruction()];
                    case 3:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 1];
                    case 5:
                        if (transaction.instructions.length > 0) {
                            return [2 /*return*/, transaction];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TokenDevesting.prototype.createMultisigTransfer = function (index, transferTo) {
        return __awaiter(this, void 0, void 0, function () {
            var vestingType, config, multisig, multisigToken, transfer, vestingTypeData, transaction, instructionParams, _i, transferTo_1, transfer_1, associatedPubkey, instance, instructionData, signDevestingInstruction, _a, _b, _c, _d;
            var _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 1:
                        vestingType = _f.sent();
                        return [4 /*yield*/, this.configAccessor.existing()];
                    case 2:
                        config = _f.sent();
                        return [4 /*yield*/, this.multisigAccessor.existing()];
                    case 3:
                        multisig = _f.sent();
                        return [4 /*yield*/, this.multisigTokenAccessor.existing()];
                    case 4:
                        multisigToken = _f.sent();
                        return [4 /*yield*/, this.transferActionAccessor.nonExisting({
                                actionCreator: this.sender,
                                index: index,
                            })];
                    case 5:
                        transfer = _f.sent();
                        vestingTypeData = vestingType.data;
                        if (!vestingTypeData.administrator)
                            throw Error("Vesting type does not have administrator");
                        transaction = new web3_js_1.Transaction();
                        instructionParams = [];
                        _i = 0, transferTo_1 = transferTo;
                        _f.label = 6;
                    case 6:
                        if (!(_i < transferTo_1.length)) return [3 /*break*/, 9];
                        transfer_1 = transferTo_1[_i];
                        return [4 /*yield*/, this.associatedTokenAccessor.existing(transfer_1.pubkey)];
                    case 7:
                        associatedPubkey = (_f.sent()).pubkey;
                        instructionParams.push({
                            pubkey: associatedPubkey,
                            amountLamports: transfer_1.amountLamports,
                        });
                        _f.label = 8;
                    case 8:
                        _i++;
                        return [3 /*break*/, 6];
                    case 9:
                        while (instructionParams.length < constants_1.MAX_SIGNERS) {
                            instructionParams.push({
                                pubkey: web3_js_1.PublicKey.default,
                                amountLamports: new bn_js_1.default(0),
                            });
                        }
                        instance = new schema_1.Instruction(new schema_1.TransferMultisigInstruction(instructionParams.map(function (x) { return x.amountLamports; }), instructionParams.map(function (x) { return x.pubkey; })));
                        instructionData = (0, borsh_1.serialize)(schema_1.schemas, instance);
                        _a = web3_js_1.TransactionInstruction.bind;
                        _e = {};
                        _b = [{ pubkey: this.sender, isSigner: true, isWritable: false },
                            multisig.getAccountMeta(),
                            vestingType.getAccountMeta(),
                            multisigToken.getWritableAccountMeta()];
                        return [4 /*yield*/, vestingType.getMultisigTokenPdaAccountMeta()];
                    case 10:
                        signDevestingInstruction = new (_a.apply(web3_js_1.TransactionInstruction, [void 0, (_e.keys = _b.concat([
                                _f.sent(),
                                { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
                                config.getAccountMeta(),
                                transfer.getWritableAccountMeta(),
                                {
                                    pubkey: vestingTypeData.administrator,
                                    isSigner: false,
                                    isWritable: true,
                                }
                            ]),
                                _e.programId = this.programId,
                                _e.data = Buffer.from(instructionData),
                                _e)]))();
                        _d = (_c = transaction).add;
                        return [4 /*yield*/, transfer.getCreateInstruction()];
                    case 11:
                        _d.apply(_c, [_f.sent()]);
                        transaction.add(signDevestingInstruction);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenDevesting.prototype.signMultisigTransfer = function (actionCreator, index) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var vestingType, config, multisig, multisigToken, transfer, vestingTypeData, transferData, transaction, instance, instructionData, signDevestingInstruction, _b, _c;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 1:
                        vestingType = _e.sent();
                        return [4 /*yield*/, this.configAccessor.existing()];
                    case 2:
                        config = _e.sent();
                        return [4 /*yield*/, this.multisigAccessor.existing()];
                    case 3:
                        multisig = _e.sent();
                        return [4 /*yield*/, this.multisigTokenAccessor.existing()];
                    case 4:
                        multisigToken = _e.sent();
                        return [4 /*yield*/, this.transferActionAccessor.existing({
                                actionCreator: actionCreator,
                                index: index,
                            })];
                    case 5:
                        transfer = _e.sent();
                        vestingTypeData = vestingType.data;
                        transferData = transfer.data;
                        if (!vestingTypeData.administrator)
                            throw Error("Vesting type does not have administrator");
                        transaction = new web3_js_1.Transaction();
                        instance = new schema_1.Instruction(new schema_1.TransferMultisigInstruction(transferData.amounts, transferData.accounts_to_transfers));
                        instructionData = (0, borsh_1.serialize)(schema_1.schemas, instance);
                        _b = web3_js_1.TransactionInstruction.bind;
                        _d = {};
                        _c = [{ pubkey: this.sender, isSigner: true, isWritable: false },
                            multisig.getAccountMeta(),
                            vestingType.getAccountMeta(),
                            multisigToken.getWritableAccountMeta()];
                        return [4 /*yield*/, vestingType.getMultisigTokenPdaAccountMeta()];
                    case 6:
                        signDevestingInstruction = new (_b.apply(web3_js_1.TransactionInstruction, [void 0, (_d.keys = _c.concat([
                                _e.sent(),
                                { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
                                config.getAccountMeta(),
                                transfer.getWritableAccountMeta(),
                                {
                                    pubkey: vestingTypeData.administrator,
                                    isSigner: false,
                                    isWritable: true,
                                }
                            ]),
                                _d.programId = this.programId,
                                _d.data = Buffer.from(instructionData),
                                _d)]))();
                        (_a = transferData.accounts_to_transfers) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return !x.equals(web3_js_1.PublicKey.default); }).forEach(function (x) {
                            return signDevestingInstruction.keys.push({
                                pubkey: x,
                                isSigner: false,
                                isWritable: true,
                            });
                        });
                        transaction.add(signDevestingInstruction);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenDevesting.prototype.getDevestingStatistic = function (actionCreator, vestingReceiver) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var multisig, multisigToken, devesting, multisigData, multisigTokenData, devestingData, signed, unsigned;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.multisigAccessor.existing()];
                    case 1:
                        multisig = _d.sent();
                        return [4 /*yield*/, this.multisigTokenAccessor.existing()];
                    case 2:
                        multisigToken = _d.sent();
                        return [4 /*yield*/, this.devestingActionAccessor.get({
                                actionCreator: actionCreator,
                                vestingReceiver: vestingReceiver,
                            })];
                    case 3:
                        devesting = _d.sent();
                        multisigData = multisig.data;
                        multisigTokenData = multisigToken.data;
                        if (devesting.storage === null) {
                            return [2 /*return*/, new query_1.DevestingStatistics(false, new bn_js_1.default(multisigTokenData.amount), null, null, null)];
                        }
                        devestingData = devesting.data;
                        signed = [];
                        unsigned = [];
                        (_a = multisigData.require_signers) === null || _a === void 0 ? void 0 : _a.forEach(function (x, i) {
                            var _a;
                            if (x.equals(web3_js_1.PublicKey.default)) {
                                return;
                            }
                            if ((_a = devestingData.require_signers) === null || _a === void 0 ? void 0 : _a[i]) {
                                signed.push(x);
                            }
                            else {
                                unsigned.push(x);
                            }
                        });
                        return [2 /*return*/, new query_1.DevestingStatistics(true, new bn_js_1.default(multisigTokenData.amount), signed, unsigned, (_c = (_b = multisigData.require_numbers) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : null)];
                }
            });
        });
    };
    TokenDevesting.prototype.getMultisigTransferStatistic = function (actionCreator, index) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var multisig, multisigToken, transfer, multisigData, multisigTokenData, transferData, signed, unsigned, transfers;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.multisigAccessor.existing()];
                    case 1:
                        multisig = _c.sent();
                        return [4 /*yield*/, this.multisigTokenAccessor.existing()];
                    case 2:
                        multisigToken = _c.sent();
                        return [4 /*yield*/, this.transferActionAccessor.get({
                                actionCreator: actionCreator,
                                index: index,
                            })];
                    case 3:
                        transfer = _c.sent();
                        multisigData = multisig.data;
                        multisigTokenData = multisigToken.data;
                        if (transfer.storage === null) {
                            return [2 /*return*/, new query_1.MultisigTransferStatistics(false, new bn_js_1.default(multisigTokenData.amount), null, null, null, null)];
                        }
                        transferData = transfer.data;
                        if (!multisigData.require_signers ||
                            !transferData.accounts_to_transfers ||
                            !transferData.amounts)
                            throw Error("Deserialization error");
                        signed = [];
                        unsigned = [];
                        multisigData.require_signers.forEach(function (x, i) {
                            var _a;
                            if (x.equals(web3_js_1.PublicKey.default)) {
                                return;
                            }
                            if ((_a = transferData.require_signers) === null || _a === void 0 ? void 0 : _a[i]) {
                                signed.push(x);
                            }
                            else {
                                unsigned.push(x);
                            }
                        });
                        transfers = transferData.accounts_to_transfers
                            .filter(function (x) { return !x.equals(web3_js_1.PublicKey.default); })
                            .map(function (x, i) {
                            return {
                                address: x,
                                amountLamports: transferData.amounts[i],
                            };
                        });
                        return [2 /*return*/, new query_1.MultisigTransferStatistics(true, new bn_js_1.default(multisigTokenData.amount), signed, unsigned, (_b = (_a = multisigData.require_numbers) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null, transfers)];
                }
            });
        });
    };
    TokenDevesting.prototype.findDevestingCreator = function (vestingReceiver) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var multisig, multisigData, _i, _b, wallet, devesting;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.multisigAccessor.existing()];
                    case 1:
                        multisig = _c.sent();
                        multisigData = multisig.data;
                        _i = 0, _b = (_a = multisigData.require_signers) !== null && _a !== void 0 ? _a : [];
                        _c.label = 2;
                    case 2:
                        if (!(_i < _b.length)) return [3 /*break*/, 5];
                        wallet = _b[_i];
                        return [4 /*yield*/, this.devestingActionAccessor.get({
                                actionCreator: wallet,
                                vestingReceiver: vestingReceiver,
                            })];
                    case 3:
                        devesting = _c.sent();
                        if (devesting.data !== null) {
                            return [2 /*return*/, wallet];
                        }
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, null];
                }
            });
        });
    };
    TokenDevesting.prototype.getMultisigData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var account;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.multisigAccessor.existing()];
                    case 1:
                        account = _a.sent();
                        return [2 /*return*/, account.data];
                }
            });
        });
    };
    return TokenDevesting;
}(token_vesing_1.TokenVesting));
exports.TokenDevesting = TokenDevesting;
//# sourceMappingURL=token-devesting.js.map